import { render, staticRenderFns } from "./APILoader.vue?vue&type=template&id=7beabbdf&"
import script from "./APILoader.vue?vue&type=script&lang=js&"
export * from "./APILoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports